import {
  avatarUrl,
  displayName,
  remoteUserId,
  userEmail,
  userId,
} from '../constants/stringsAndFields';
import {upsertAppUser} from '../database/user';

export async function persistSupabaseUserToLocalDb(tx, user) {
  const row = {
    [userId]: user.id,
    [userEmail]: user.email ?? null,
    [displayName]:
      user.user_metadata?.full_name ??
      user.user_metadata?.name ??
      user.user_metadata?.display_name ??
      null,
    [avatarUrl]: user.user_metadata?.avatar_url ?? null,
    [remoteUserId]: user.id,
  };
  await upsertAppUser(tx, row);
}
